import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from '../components/AnimatedSection';

const sections = [
  {
    id: 'refund',
    icon: '💰',
    title: 'Withdrawal and Refund Policy',
    color: '#3b82f6',
    content: [
      {
        type: 'intro',
        text: 'At Saanvi Innovations, we strive to deliver exceptional quality in all our services. We understand that circumstances may change, and we have established the following refund policy to ensure fairness for all parties.',
      },
      {
        type: 'heading',
        text: 'Project Cancellation & Refund Terms',
      },
      {
        type: 'list',
        items: [
          'If a project is cancelled before commencement of work, a full refund will be issued minus any administrative fees.',
          'If a project is cancelled after work has commenced but before 25% completion, a 75% refund will be issued on the remaining balance.',
          'If a project is cancelled after 25-50% completion, a 50% refund will be issued on the remaining balance.',
          'If a project is cancelled after 50% or more completion, no refund will be issued as significant resources and time have been invested.',
          'Refunds are processed within 7-10 business days from the date of cancellation confirmation.',
          'All refund requests must be submitted in writing to ceo@saanviInnovations.com.',
        ],
      },
      {
        type: 'heading',
        text: 'Non-Refundable Services',
      },
      {
        type: 'list',
        items: [
          'Domain registration and renewal fees are non-refundable once processed.',
          'Third-party software licenses and subscriptions purchased on behalf of clients are non-refundable.',
          'Completed milestones that have been approved by the client are non-refundable.',
          'Hosting charges paid for active services are non-refundable.',
          'Digital marketing campaigns that have already been launched are non-refundable.',
        ],
      },
      {
        type: 'heading',
        text: 'Exceptions',
      },
      {
        type: 'text',
        text: 'In cases where Saanvi Innovations is unable to deliver the agreed-upon services within the specified timeline without prior notice or valid reason, a full refund will be considered. Each case will be evaluated individually by the management team.',
      },
    ],
  },
  {
    id: 'privacy',
    icon: '🔒',
    title: 'Privacy Policy',
    color: '#8b5cf6',
    content: [
      {
        type: 'intro',
        text: 'Your privacy is important to us. This Privacy Policy explains how Saanvi Innovations collects, uses, stores, and protects your personal information when you use our services or visit our website.',
      },
      {
        type: 'heading',
        text: 'Information We Collect',
      },
      {
        type: 'list',
        items: [
          'Personal identification information (name, email address, phone number, etc.)',
          'Business information (company name, address, nature of business)',
          'Technical information (IP address, browser type, device information)',
          'Usage data (pages visited, time spent on website, referral sources)',
          'Communication records (emails, messages, call logs)',
          'Financial information required for billing purposes (securely handled)',
        ],
      },
      {
        type: 'heading',
        text: 'How We Use Your Information',
      },
      {
        type: 'list',
        items: [
          'To provide and improve our services to you',
          'To process transactions and send related information',
          'To communicate with you about your projects and services',
          'To send periodic newsletters and promotional communications (with your consent)',
          'To comply with legal obligations and enforce our terms',
          'To analyze website usage and improve user experience',
        ],
      },
      {
        type: 'heading',
        text: 'Data Protection & Security',
      },
      {
        type: 'text',
        text: 'We implement industry-standard security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. Your data is stored on secure servers and encrypted using SSL technology. We never sell or rent your personal information to third parties.',
      },
      {
        type: 'heading',
        text: 'Cookies Policy',
      },
      {
        type: 'text',
        text: 'Our website uses cookies to enhance your browsing experience. You can control cookie settings through your browser preferences. Essential cookies are necessary for the website to function properly and cannot be disabled.',
      },
      {
        type: 'heading',
        text: 'Your Rights',
      },
      {
        type: 'list',
        items: [
          'Right to access your personal data we hold',
          'Right to request correction of inaccurate data',
          'Right to request deletion of your personal data',
          'Right to withdraw consent at any time',
          'Right to data portability',
          'Right to lodge a complaint with supervisory authorities',
        ],
      },
    ],
  },
  {
    id: 'dispute',
    icon: '⚖️',
    title: 'Dispute Resolution',
    color: '#10b981',
    content: [
      {
        type: 'intro',
        text: 'Saanvi Innovations is committed to resolving any disputes or concerns in a fair, transparent, and timely manner. We believe in maintaining positive relationships with all our clients.',
      },
      {
        type: 'heading',
        text: 'Resolution Process',
      },
      {
        type: 'text',
        text: 'The solution of all the problems of the customer will be at the head office Gwalior.',
      },
      {
        type: 'list',
        items: [
          'Step 1: Submit your complaint in writing to ceo@saanviInnovation.com with detailed description.',
          'Step 2: Our team will acknowledge receipt within 48 hours of receiving the complaint.',
          'Step 3: A dedicated team member will be assigned to investigate the matter.',
          'Step 4: We aim to resolve all disputes within 7-14 working days.',
          'Step 5: If unsatisfied with the resolution, escalation to senior management is available.',
          'Step 6: All disputes are subject to the jurisdiction of courts in Gwalior, Madhya Pradesh.',
        ],
      },
      {
        type: 'heading',
        text: 'Contact for Disputes',
      },
      {
        type: 'text',
        text: 'For all dispute-related matters, please visit or contact our head office at: 21, Nehru Colony, Near Vivekanand Chauraha, Thatipur, Gwalior (M.P). Email: ceo@saanviInnovation.com',
      },
    ],
  },
  {
    id: 'cancellation',
    icon: '❌',
    title: 'Cancellation Policy',
    color: '#f59e0b',
    content: [
      {
        type: 'intro',
        text: 'We understand that plans can change. Our cancellation policy is designed to be fair to both our clients and our team. Please read the following terms carefully before engaging our services.',
      },
      {
        type: 'heading',
        text: 'Service Cancellation Terms',
      },
      {
        type: 'list',
        items: [
          'Cancellation requests must be submitted in writing via email to ceo@saanviInnovation.com.',
          'A minimum notice period of 15 days is required for cancellation of ongoing services.',
          'Projects cancelled within 48 hours of signing the agreement are eligible for a full refund.',
          'Monthly retainer services can be cancelled with 30 days advance notice.',
          'Cancellation fees may apply depending on the stage of the project and resources already allocated.',
        ],
      },
      {
        type: 'heading',
        text: 'Cancellation by Saanvi Innovations',
      },
      {
        type: 'list',
        items: [
          'We reserve the right to cancel a project if the client fails to provide required information or approvals within reasonable time.',
          'Repeated non-payment or late payment may result in project suspension or cancellation.',
          'If we cancel a project due to our inability to deliver, a full refund of outstanding payments will be made.',
          'We will provide minimum 15 days notice before cancelling any active service contracts.',
        ],
      },
      {
        type: 'heading',
        text: 'Post-Cancellation',
      },
      {
        type: 'list',
        items: [
          'Upon cancellation, all deliverables completed up to that point will be provided to the client.',
          'Access to project management tools and communication channels will be revoked after 30 days.',
          'All client-provided materials and data will be returned or securely deleted as per client preference.',
          'Non-disclosure agreements remain in effect even after project cancellation.',
          'Any outstanding invoices must be cleared before final project files are handed over.',
        ],
      },
      {
        type: 'heading',
        text: 'Governing Law',
      },
      {
        type: 'text',
        text: 'These terms and conditions are governed by the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts located in Gwalior, Madhya Pradesh, India.',
      },
    ],
  },
];

const Terms = () => {
  const [activeSection, setActiveSection] = useState('refund');

  return (
    <div>
      <style>{`
        .terms-layout {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 40px;
          align-items: start;
        }
        .terms-nav {
          background: white;
          border-radius: 16px;
          padding: 24px;
          border: 1px solid #e9ecef;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          position: sticky;
          top: 100px;
        }
        .terms-nav h3 {
          font-size: 0.78rem; font-weight: 700;
          color: #6c757d; letter-spacing: 2px;
          text-transform: uppercase; margin-bottom: 16px;
        }
        .terms-nav-item {
          display: flex; align-items: center; gap: 12px;
          padding: 12px 14px;
          border-radius: 10px;
          cursor: pointer;
          font-size: 0.88rem;
          font-weight: 500;
          color: #6c757d;
          transition: all 0.3s ease;
          border: none; background: none;
          width: 100%; text-align: left;
          margin-bottom: 4px;
        }
        .terms-nav-item:hover {
          background: #f8f9fa;
          color: #1a1a5e;
        }
        .terms-nav-item.active {
          background: linear-gradient(135deg, #f0f2ff, #e8eaff);
          color: #1a1a5e; font-weight: 600;
        }
        .terms-nav-icon {
          width: 32px; height: 32px;
          border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          font-size: 1rem; flex-shrink: 0;
        }
        .terms-content { display: flex; flex-direction: column; gap: 20px; }
        .terms-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          border: 1px solid #e9ecef;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          scroll-margin-top: 100px;
          transition: all 0.3s ease;
        }
        .terms-card.highlight {
          border-color: #1a1a5e;
          box-shadow: 0 8px 30px rgba(26,26,94,0.12);
        }
        .terms-card-header {
          padding: 24px 30px;
          display: flex; align-items: center; gap: 16px;
        }
        .terms-header-icon {
          width: 50px; height: 50px;
          border-radius: 14px;
          display: flex; align-items: center; justify-content: center;
          font-size: 1.5rem; background: rgba(255,255,255,0.25);
          flex-shrink: 0;
        }
        .terms-card-header h2 {
          font-size: 1.2rem; font-weight: 800;
          color: white; margin: 0;
        }
        .terms-card-body { padding: 30px; }
        .terms-intro {
          background: #f8f9fa; border-radius: 10px;
          padding: 16px 20px; margin-bottom: 24px;
          font-size: 0.9rem; color: #495057; line-height: 1.8;
          border-left: 4px solid #1a1a5e;
        }
        .terms-h3 {
          font-size: 1rem; font-weight: 700;
          color: #1a1a5e; margin: 20px 0 12px;
          padding-bottom: 8px;
          border-bottom: 2px solid #f0f0f0;
        }
        .terms-text {
          font-size: 0.9rem; color: #495057;
          line-height: 1.85; margin-bottom: 12px;
        }
        .terms-list { list-style: none; padding: 0; margin: 0 0 12px; }
        .terms-list li {
          display: flex; gap: 12px;
          padding: 8px 0;
          font-size: 0.88rem; color: #495057;
          line-height: 1.7;
          border-bottom: 1px solid #f5f5f5;
        }
        .terms-list li:last-child { border-bottom: none; }
        .terms-list li::before {
          content: '→';
          color: #ff6b35; font-weight: 700;
          flex-shrink: 0; margin-top: 1px;
        }
        .last-updated {
          text-align: center;
          padding: 20px;
          background: #f8f9fa;
          border-radius: 10px;
          color: #6c757d;
          font-size: 0.85rem;
          margin-top: 20px;
        }
        @media (max-width: 1024px) { .terms-layout { grid-template-columns: 1fr; } .terms-nav { position: static; } }
        @media (max-width: 640px) { .terms-card-body { padding: 20px; } }
      `}</style>

      {/* Hero */}
      <div className="page-hero">
        <div className="container">
          <AnimatedSection>
            <h1 className="page-hero-title">Terms & <span>Conditions</span></h1>
            <p className="page-hero-subtitle">
              Please read our terms carefully before using our services
            </p>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Terms & Conditions</span>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Terms Content */}
      <section className="section-padding">
        <div className="container">
          <AnimatedSection className="section-header">
            <span className="section-tag">Legal</span>
            <h2 className="section-title">Our <span>Policies</span></h2>
            <div className="section-divider"><span></span><span></span><span></span></div>
            <p className="section-subtitle">
              These terms govern your use of our services. Last updated: January 2024.
            </p>
          </AnimatedSection>

          <div className="terms-layout">
            {/* Sidebar Nav */}
            <div className="terms-nav">
              <h3>Quick Navigation</h3>
              {sections.map(s => (
                <button
                  key={s.id}
                  className={`terms-nav-item ${activeSection === s.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveSection(s.id);
                    document.getElementById(s.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }}
                >
                  <div className="terms-nav-icon" style={{ background: `${s.color}15` }}>
                    {s.icon}
                  </div>
                  <span style={{ lineHeight: 1.3 }}>{s.title}</span>
                </button>
              ))}
              <div style={{ marginTop: '20px', padding: '16px', background: '#f8f9fa', borderRadius: '10px', fontSize: '0.82rem', color: '#6c757d', lineHeight: 1.7 }}>
                <strong style={{ color: '#1a1a5e' }}>Questions?</strong><br />
                Contact us at<br />
                <a href="mailto:ceo@saanviInnovation.com" style={{ color: '#ff6b35', fontWeight: 600 }}>
                  ceo@saanviInnovation.com
                </a>
              </div>
            </div>

            {/* Content */}
            <div className="terms-content">
              {sections.map(s => (
                <div
                  key={s.id}
                  id={s.id}
                  className={`terms-card ${activeSection === s.id ? 'highlight' : ''}`}
                >
                  <div
                    className="terms-card-header"
                    style={{ background: `linear-gradient(135deg, ${s.color}, ${s.color}bb)` }}
                  >
                    <div className="terms-header-icon">{s.icon}</div>
                    <h2>{s.title}</h2>
                  </div>
                  <div className="terms-card-body">
                    {s.content.map((block, bi) => {
                      if (block.type === 'intro') return (
                        <div key={bi} className="terms-intro">{block.text}</div>
                      );
                      if (block.type === 'heading') return (
                        <h3 key={bi} className="terms-h3">{block.text}</h3>
                      );
                      if (block.type === 'text') return (
                        <p key={bi} className="terms-text">{block.text}</p>
                      );
                      if (block.type === 'list') return (
                        <ul key={bi} className="terms-list">
                          {block.items.map((item, ii) => <li key={ii}>{item}</li>)}
                        </ul>
                      );
                      return null;
                    })}
                  </div>
                </div>
              ))}

              <div className="last-updated">
                📅 These terms were last updated on <strong>January 1, 2024</strong>.
                For any questions, email us at{' '}
                <a href="mailto:ceo@saanviInnovation.com" style={{ color: '#ff6b35', fontWeight: 600 }}>
                  ceo@saanviInnovation.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
